import { useRenew } from "./flow/context";
import { RenewIntro } from "./RenewIntro";

export function RenewIntroScreen() {
  const {
    customerState,
    expirationDate,
    earlyTerminationFee,
    noOffers,
    onLogout,
    next,
  } = useRenew();

  return (
    <RenewIntro
      customerState={customerState}
      expirationDate={expirationDate}
      earlyTerminationFee={earlyTerminationFee}
      noOffers={noOffers}
      onLogout={onLogout}
      onGetStarted={() => {
        void next();
      }}
    />
  );
}
